import { useState } from 'react';
import { Target, Sparkles, Users, User, Filter, ArrowRight, Lightbulb, BarChart } from 'lucide-react';
import RecommendationsPanel from '../components/Aiguille/RecommendationsPanel';
import MatchingPanel from '../components/Aiguille/MatchingPanel';
import ProfilDynamiquePanel from '../components/Aiguille/ProfilDynamiquePanel';
import PasserellesPanel from '../components/Aiguille/PasserellesPanel';
import FiltresAvancesPanel from '../components/Aiguille/FiltresAvancesPanel';
import IAExplicativePanel from '../components/Aiguille/IAExplicativePanel';

export default function Aiguille() {
  const [activeTab, setActiveTab] = useState('recommandations');

  const tabs = [
    { id: 'recommandations', label: 'Recommandations', icon: Sparkles, component: RecommendationsPanel },
    { id: 'matching', label: 'Matching', icon: Users, component: MatchingPanel },
    { id: 'profil', label: 'Profil Dynamique', icon: User, component: ProfilDynamiquePanel },
    { id: 'passerelles', label: 'Passerelles Métiers', icon: ArrowRight, component: PasserellesPanel },
    { id: 'filtres', label: 'Filtres Avancés', icon: Filter, component: FiltresAvancesPanel },
    { id: 'ia', label: 'IA Explicative', icon: Lightbulb, component: IAExplicativePanel }
  ];

  const ActiveComponent = tabs.find(tab => tab.id === activeTab)?.component;

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 p-6">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="mb-8">
          <div className="flex items-center gap-3 mb-2">
            <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-purple-500 to-pink-500 flex items-center justify-center text-white shadow-lg">
              <Target className="w-6 h-6" />
            </div>
            <div>
              <h1 className="text-3xl font-heading font-bold text-gray-900">Aiguille</h1>
              <p className="text-gray-600">Recommandations personnalisées & IA d'aide à la décision</p>
            </div>
          </div>
        </div>

        {/* Tabs Navigation */}
        <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-2 mb-6">
          <div className="flex flex-wrap gap-2">
            {tabs.map((tab) => {
              const Icon = tab.icon;
              return (
                <button
                  key={tab.id}
                  onClick={() => setActiveTab(tab.id)}
                  className={`flex items-center gap-2 px-4 py-2.5 rounded-lg font-medium transition-all ${
                    activeTab === tab.id
                      ? 'bg-gradient-to-r from-purple-500 to-pink-500 text-white shadow-md'
                      : 'text-gray-600 hover:bg-gray-100'
                  }`}
                >
                  <Icon className="w-4 h-4" />
                  <span className="hidden sm:inline">{tab.label}</span>
                </button>
              );
            })}
          </div>
        </div>

        {/* Active Component */}
        <div className="animate-fadeIn">
          {ActiveComponent && <ActiveComponent />}
        </div>

        {/* Info Footer */}
        <div className="mt-8 bg-blue-50 border border-blue-200 rounded-xl p-6">
          <div className="flex items-start gap-3">
            <div className="w-10 h-10 bg-blue-100 rounded-lg flex items-center justify-center flex-shrink-0">
              <BarChart className="w-5 h-5 text-blue-600" />
            </div>
            <div>
              <h3 className="font-semibold text-blue-900 mb-2">Module Aiguille - Fonctionnalités</h3>
              <div className="text-sm text-blue-800 space-y-1">
                <p><strong>Recommandations personnalisées :</strong> Formations adaptées à votre profil et compétences</p>
                <p><strong>Matching intelligent :</strong> Correspondances optimales avec formations et certifications</p>
                <p><strong>Profil dynamique :</strong> Visualisation de votre empreinte de compétences évolutive</p>
                <p><strong>Passerelles métiers :</strong> Suggestions de mobilité professionnelle avec score de difficulté</p>
                <p><strong>Filtres avancés :</strong> Recherche multicritères (géographie, secteur, accessibilité, niveau)</p>
                <p><strong>IA explicative :</strong> Justifications transparentes des recommandations avec points forts/faibles</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}